import { initialsOf } from "@/lib/events";

// One speaker tile. Falls back to a brass initials chip when `photo` is null,
// which is the default while we collect real portrait photos.
export default function SpeakerCard({ speaker }) {
  if (!speaker) return null;
  const { name, role, title, bio, photo } = speaker;

  return (
    <article
      data-testid={`speaker-card-${name.toLowerCase().replace(/[^a-z]/g, "-")}`}
      className="group border border-black/10 bg-parchment p-6 md:p-8 hover:border-spice transition-colors"
    >
      <div className="flex items-start gap-5">
        {photo ? (
          <img
            src={photo}
            alt={`Portrait of ${name}`}
            className="w-16 h-16 md:w-20 md:h-20 object-cover rounded-full border border-black/10 shrink-0"
            loading="lazy"
          />
        ) : (
          <div
            aria-hidden="true"
            className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-brass/15 text-brass border border-brass/30 flex items-center justify-center font-serif text-xl md:text-2xl shrink-0"
          >
            {initialsOf(name)}
          </div>
        )}
        <div className="min-w-0">
          <div className="overline text-spice mb-1">{role}</div>
          <h3 className="font-serif text-2xl md:text-3xl leading-tight">{name}</h3>
          {title && (
            <div className="text-ocean/60 text-sm mt-1 leading-snug">{title}</div>
          )}
        </div>
      </div>
      {bio && (
        <p className="mt-5 text-ocean/75 text-sm md:text-base leading-relaxed">
          {bio}
        </p>
      )}
    </article>
  );
}
